export enum SceneEvent {
	FRAME_RANGE_UPDATED = 'scene_frameRangeUpdated',
	REALTIME_STATUS_UPDATED = 'scene_realtime_status_updated',
	FRAME_UPDATED = 'scene_frame_updated',
	PLAY_STATE_UPDATED = 'scene_play_state_updated',
}
